import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import API, {
  ACCESS_TOKEN_KEY,
} from "../axiosInstance";

import "./LoginDesign.css";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");

    try {
      const response = await API.post(
        "/auth/login",
        {
          email,
          password,
        },
        {
          withCredentials: true,
        }
      );

      if (
        !response.data?.success ||
        !response.data?.user
      ) {
        setError("Identifiants incorrects");
        return;
      }

      localStorage.setItem(
        "currentUser",
        JSON.stringify(response.data.user)
      );

      if (response.data.accessToken) {
        localStorage.setItem(
          ACCESS_TOKEN_KEY,
          response.data.accessToken
        );
      } else {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
      }

      const user = response.data.user;
      const normalizedEmail = String(
        user.email || ""
      ).toLowerCase();

      const isAdmin =
        user.is_admin === 1 ||
        user.is_admin === true ||
        normalizedEmail ===
          "admin.live.evo@gmail.com";

      if (isAdmin) {
        window.location.href = "/admin";
        return;
      }

      window.location.href = `/user/${user.pseudo}`;
    } catch (loginError) {
      console.error(
        "Erreur login :",
        loginError
      );

      setError(
        loginError.response?.data?.error ||
          "Erreur serveur"
      );
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-left">
          <img
            src="/assets/evo-logo.png"
            alt="logo"
            className="login-logo"
          />

          <h2>Login</h2>

          <form
            onSubmit={handleLogin}
            className="login-form"
          >
            <input
              type="email"
              placeholder="Adresse e-mail"
              value={email}
              onChange={(event) =>
                setEmail(event.target.value)
              }
              required
            />

            <input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(event) =>
                setPassword(event.target.value)
              }
              required
            />

            {error && (
              <p className="login-error">
                {error}
              </p>
            )}

            <button
              type="submit"
              className="login-btn"
            >
              Se connecter
            </button>
          </form>

          <p className="login-switch">
            Pas encore de compte ?{" "}
            <span
              onClick={() =>
                navigate("/register")
              }
            >
              Inscris-toi
            </span>
          </p>
        </div>

        <div className="login-right">
          <h1>WELCOME BACK!</h1>
          <p>
            Content de vous revoir sur EVO-LIVE ✨
          </p>
        </div>
      </div>
    </div>
  );
}
